import MDescriptionList from "./MDescriptionList.vue";
export { default as MDescriptionListItem } from "./MDescriptionListItem";

export default MDescriptionList;
